export default __webpack_public_path__ + "static/media/problem_solv_active.4e1cc625.svg";